// Content model for the entire portfolio.

export const CONTACT = {
  email: "hello@parinmajithia.com",
  phone: "+91 84333 34441",
  phone_e164: "+918433334441",
  whatsapp: "918433334441",
  instagram: "https://instagram.com/parin_majithia",
  instagram_handle: "@parin_majithia",
  linkedin: "https://linkedin.com/in/parinmajithia",
};

export const NAV = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "journey", label: "Journey" },
  { id: "ami-one", label: "AMI ONE" },
  { id: "yourhomes", label: "YourHomes" },
  { id: "achievements", label: "Achievements" },
  { id: "insights", label: "Insights" },
  { id: "contact", label: "Contact" },
];

export const HERO_LINES = [
  "Building the Future of Mumbai,",
  "One Thoughtful Space",
  "at a Time.",
];

export const JOURNEY = [
  { no: "01", title: "Diploma in Interior Design", note: "Foundations in space, light, materiality." },
  { no: "02", title: "Degree in Architecture", note: "Formal training in built form and systems." },
  { no: "03", title: "Second-Generation Real Estate", note: "Entered the family business in Mumbai." },
  { no: "04", title: "Consulting & Development", note: "Expanded into advisory and ground-up projects." },
  { no: "05", title: "Co-founded YourHomes", note: "Advisory for HNIs, NRIs and serious investors." },
  { no: "06", title: "Partner — AMI WISEOWLZZ REALTY", note: "Development platform for boutique projects." },
  { no: "07", title: "Developing AMI ONE, Borivali West", note: "A G+10 residential landmark in the making." },
  { no: "08", title: "Industry Recognition", note: "Awarded across international & luxury RE." },
];

export const AMI_TABS = [
  {
    id: "philosophy",
    label: "Philosophy",
    body:
      "AMI ONE is designed as a quieter kind of luxury — a low-density, boutique residence where privacy is not an amenity but the plan itself. Every decision, from the three-side open plot to only two homes per floor, is oriented around light, air and dignity of living.",
    stat: "G+10 · 2 per floor",
  },
  {
    id: "progress",
    label: "Progress",
    body:
      "Construction is progressing on schedule. The sample apartment is ready and open for private walk-throughs — a chance to see the material palette, the light behaviour and the sense of scale in person, before completion.",
    stat: "Sample apartment · Ready",
  },
  {
    id: "design",
    label: "Design",
    body:
      "Thoughtfully planned 2-bedroom homes of approximately 600 sq. ft. carpet area, with exclusive full-floor Jodi apartment options. Twin elevators, efficient cores and calm interior detailing — a plan drawn to reduce friction inside daily life.",
    stat: "~600 sq. ft. carpet · Jodi option",
  },
  {
    id: "location",
    label: "Location",
    body:
      "Situated off SVP Road, Borivali West — an established Mumbai neighbourhood with strong social infrastructure, transit connectivity and long-term real-estate stability. The site is chosen for how it lives, not just how it looks on a map.",
    stat: "SVP Road · Borivali West",
  },
  {
    id: "gallery",
    label: "Gallery",
    body:
      "A visual index of the tower, plan diagrams, material studies and the completed sample residence. Photography and drawings are treated as documents of intent — not marketing decoration.",
    stat: "Renders · Plans · Sample",
  },
];

export const AMI_HIGHLIGHTS = [
  "Boutique G+10 storey development",
  "Only two residences per floor",
  "Three-side open plot",
  "Twin elevators",
  "~600 sq. ft. carpet — 2-bed homes",
  "Exclusive full-floor Jodi option",
  "Off SVP Road, Borivali West",
  "Sample apartment ready to view",
];

export const YOURHOMES_SERVICES = [
  { k: "01", t: "Real-estate advisory", d: "Independent, research-led guidance for buyers and investors." },
  { k: "02", t: "Luxury property consulting", d: "Curated inventory across Mumbai's premium micro-markets." },
  { k: "03", t: "Developer representation", d: "Positioning, launch strategy and disciplined channel sales." },
  { k: "04", t: "Investment opportunities", d: "Pre-launch, distressed and yield-focused RE plays." },
  { k: "05", t: "HNI & NRI clients", d: "Full-service handling, from selection to documentation." },
  { k: "06", t: "Direct, transparent guidance", d: "No noise, no pressure — just clear numbers and clear plans." },
];

export const ACHIEVEMENTS = [
  { year: "2025", title: "International Property Consultant of the Year", org: "Industry recognition" },
  { year: "2026", title: "Luxury Real Estate Consultant of the Year", org: "Industry recognition" },
  { year: "—", title: "Majithia Brothers · YourHomes", org: "Featured recognition" },
  { year: "—", title: "Member of PEATA", org: "Practicing Engineers, Architects & Town Planners Association (India)" },
  { year: "—", title: "Architect & Developer, AMI ONE", org: "Low-density boutique project" },
  { year: "—", title: "Architecture · Interiors · Development · Consulting · Marketing", org: "Multidisciplinary practice" },
];

export const PRINCIPLES = [
  { k: "I", t: "Design with purpose", d: "Every plan should answer a question about how people actually live." },
  { k: "II", t: "Build with transparency", d: "Numbers, timelines and decisions are shared with clients openly." },
  { k: "III", t: "Adopt technology", d: "Modern tools compress guesswork — we use them at every stage." },
  { k: "IV", t: "Create long-term value", d: "A project must age well, financially and architecturally." },
];

export const TECH_LIST = [
  "Architectural visualisation",
  "Digital marketing",
  "Real-estate lead generation",
  "Project communication",
  "Construction monitoring",
  "Brand building",
  "Artificial intelligence & emerging tools",
];

export const INSIGHTS = [
  {
    tag: "Feature",
    date: "The Statesman · 2021",
    title: "Parin Majithia has carved a niche in the field of designing with perseverance",
    excerpt:
      "\"They stay with you through the entire process and guide you in every aspect.\" — a feature on Parin's approach to design and long-term client relationships.",
    href:
      "https://www.thestatesman.com/inspiration-hub/parin-majithia-carved-niche-field-designing-perseverance-1503021724.html",
    external: true,
    image: "https://images.pexels.com/photos/4458205/pexels-photo-4458205.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    tag: "Feature",
    date: "DNA India · Jul 2021",
    title: "Entrepreneur Parin Majithia's new venture to boost home buyer's experience in India",
    excerpt:
      "How Parin's minimalist, tech-first approach — YourHomes, LocalBroker and PropMost — is redefining real-estate intelligence for Indian and NRI buyers.",
    href:
      "https://www.dnaindia.com/lifestyle/report-entrepreneur-parin-majithia-s-new-venture-to-boost-home-buyer-s-experience-in-india-2902036",
    external: true,
    image: "https://images.pexels.com/photos/5316708/pexels-photo-5316708.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    tag: "Build Log",
    date: "Coming soon",
    title: "AMI ONE · From plot to plan — the first 180 days on site",
    excerpt: "Behind-the-scenes of a G+10 boutique residence — decisions, drawings, mistakes, corrections.",
    href: "#insights",
    image: "https://images.unsplash.com/photo-1636714289409-e06a4dfc617c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwbmlnaHQlMjBjcmFuZXxlbnwwfHx8fDE3ODQ0NzY4ODJ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    tag: "Essay",
    date: "Coming soon",
    title: "AI in real estate — where the hype ends and the leverage begins",
    excerpt: "Practical uses of AI for architects, developers and consultants — beyond the render.",
    href: "#insights",
    image: "https://images.pexels.com/photos/13722886/pexels-photo-13722886.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const CONTACT_CATEGORIES = [
  "Real-estate development",
  "Property consultation",
  "Architecture and design",
  "Joint ventures",
  "Project collaborations",
  "Media and speaking",
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/33948766/pexels-photo-33948766.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1600&w=2400",
  portrait: "/media/parin.jpg",
  amiFacade: "https://images.pexels.com/photos/5316708/pexels-photo-5316708.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
  construction: "https://images.unsplash.com/photo-1636714289409-e06a4dfc617c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwbmlnaHQlMjBjcmFuZXxlbnwwfHx8fDE3ODQ0NzY4ODJ8MA&ixlib=rb-4.1.0&q=85",
  blueprint: "https://images.pexels.com/photos/4458205/pexels-photo-4458205.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
  interior: "https://images.pexels.com/photos/13722886/pexels-photo-13722886.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
};
